import { FC } from 'react';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { Location } from '@edikk-edikk/icon/Location';
import cardHeaderCss from '#srcCssModules/card/card-header.module.scss';
import cardHeaderIconCss from '#srcCssModules/card/card-header-icon.module.scss';

const CardLocationHeader: FC = () => (
  <div className={cardHeaderCss.cardHeader}>
    <div className={cardHeaderIconCss.cardHeaderIcon}>
      <SvgIcon Component={Location} isWithoutStroke additionalClassName={cardHeaderIconCss.cardHeaderIcon__content} />
    </div>
  </div>
);

export { CardLocationHeader };
